import * as React from 'react'
import * as styles from './highlighted-text.module.scss'

const HighlightedText = ({value, highlight}) => {
    const highlightedText = React.useMemo(() => {
        const filterText = highlight?.toLowerCase();

        if (!filterText) {
            return value;
        }

        let text = value;

        const resultItems = [];
        let ix = -1;

        while ((ix = text.toLowerCase().indexOf(filterText)) >= 0) {
            if (ix > 0) {
                const part = text.substring(0, ix);
                resultItems.push(part);
                text = text.substring(ix);
            }

            const match = text.substring(0, filterText.length);
            resultItems.push(<mark className={styles.mark}>{match}</mark>);

            text = text.substring(filterText.length);
        }

        if (text) {
            resultItems.push(text);
        }

        return (<>
        {
            resultItems.map((i, ix) => <React.Fragment key={ix}>{i}</React.Fragment>)
        }
        </>)

    }, [value, highlight]);

    return (<>{highlightedText}</>)
}

export default HighlightedText;